export default __webpack_public_path__ + "static/media/david.b32151de.png";